import { type EbayUtmTag } from '../cms/types';

import { useBrandsBatchIds } from '@/modules/brands/hooks/useBrandsBatchIds';
import { useGroupsById } from '@/modules/categories/useGroupsById';
import { getYouMightBeIntoListFromLocalStorage } from '@/modules/product/helpers/getYouMightBeIntoListFromLocalStorage';
import { EBAY_LANDING_BLENDED_PILLS } from '@/modules/search/constants';
import {
  youMightBeIntoPillHref,
  getUniqueBrandIds,
} from '@/modules/search/helpers';
import { type YouMightBeIntoPillAttributes } from '@/modules/search/types';

export function useYouMightBeIntoPills(cohort?: EbayUtmTag) {
  const { data: groupsByIdRes } = useGroupsById({ enabled: !cohort });
  const youMightBeIntoList = cohort
    ? []
    : getYouMightBeIntoListFromLocalStorage();
  const { data: brands } = useBrandsBatchIds(
    getUniqueBrandIds(youMightBeIntoList)
  );

  if (cohort) {
    return EBAY_LANDING_BLENDED_PILLS;
  }

  const groupsById = groupsByIdRes?.data || {};
  return youMightBeIntoList.reduce<YouMightBeIntoPillAttributes[]>(
    (list, item) => {
      const { brandId, groupId, productType, isKids, gender } = item;
      const brandName = brands?.[brandId]?.name;
      const group = groupsById[groupId];
      const groupName = group?.name_i18n?.['en-US']?.toLowerCase();
      const productTypeName = group?.product_types
        ?.find((item) => item.id === productType)
        ?.name_i18n?.['en-US']?.toLowerCase();
      const friendlyName = productTypeName || groupName;

      if (!brandName || !group || !friendlyName) {
        return list;
      }
      const label = `${brandName} ${friendlyName}`;

      list.push({
        label,
        href: youMightBeIntoPillHref({
          productType,
          group: groupId,
          brandId: Number(brandId),
          searchQuery: label,
          gender,
          isKids,
        }),
      });

      return list;
    },
    []
  );
}
